import React, { useState } from 'react';
import { Card, CardBody, Button, Input, Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Chip, Tabs, Tab, Avatar, Select, SelectItem, Textarea } from '@nextui-org/react';
import HeaderComponent from '../components/General/HeaderComponent';
import { FiPlus, FiSearch, FiUsers, FiEdit2, FiTrash2, FiUser, FiMail, FiPhone, FiCalendar, FiBriefcase, FiFileText, FiMapPin } from 'react-icons/fi';
import { Notify } from 'notiflix';

export default function HumanResources() {
  const [activeTab, setActiveTab] = useState('employees');
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isEmployeeModalOpen, setIsEmployeeModalOpen] = useState(false);
  const [isDepartmentModalOpen, setIsDepartmentModalOpen] = useState(false);
  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingEmployee, setEditingEmployee] = useState(null);

  // Dummy veriler - Birimler
  const [departments, setDepartments] = useState([
    { id: 1, name: 'Yazılım Geliştirme', employeeCount: 12 },
    { id: 2, name: 'Pazarlama', employeeCount: 8 },
    { id: 3, name: 'İnsan Kaynakları', employeeCount: 3 },
    { id: 4, name: 'Satış', employeeCount: 15 },
    { id: 5, name: 'Müşteri Hizmetleri', employeeCount: 10 }
  ]);

  // Dummy veriler - Çalışanlar
  const [employees, setEmployees] = useState([
    {
      id: 1,
      firstName: 'Ahmet',
      lastName: 'Yılmaz',
      email: 'ahmet.yilmaz@heypena.com',
      phone: '+90 555 123 4567',
      position: 'Senior Developer',
      departmentId: 1,
      departmentName: 'Yazılım Geliştirme',
      hireDate: '2022-03-15',
      status: 'active',
      avatar: null
    },
    {
      id: 2,
      firstName: 'Ayşe',
      lastName: 'Kaya',
      email: 'ayse.kaya@heypena.com',
      phone: '+90 555 234 5678',
      position: 'Marketing Manager',
      departmentId: 2,
      departmentName: 'Pazarlama',
      hireDate: '2021-07-20',
      status: 'active',
      avatar: null
    },
    {
      id: 3,
      firstName: 'Mehmet',
      lastName: 'Demir',
      email: 'mehmet.demir@heypena.com',
      phone: '+90 555 345 6789',
      position: 'HR Specialist',
      departmentId: 3,
      departmentName: 'İnsan Kaynakları',
      hireDate: '2023-01-10',
      status: 'active',
      avatar: null
    },
    {
      id: 4,
      firstName: 'Fatma',
      lastName: 'Arslan',
      email: 'fatma.arslan@heypena.com',
      phone: '+90 555 456 7890',
      position: 'Sales Representative',
      departmentId: 4,
      departmentName: 'Satış',
      hireDate: '2022-09-05',
      status: 'active',
      avatar: null
    },
    {
      id: 5,
      firstName: 'Can',
      lastName: 'Öztürk',
      email: 'can.ozturk@heypena.com',
      phone: '+90 555 567 8901',
      position: 'Support Agent',
      departmentId: 5,
      departmentName: 'Müşteri Hizmetleri',
      hireDate: '2023-05-12',
      status: 'active',
      avatar: null
    }
  ]);

  // Dummy veriler - Özlük Dosyaları
  const [documents, setDocuments] = useState([
    {
      id: 1,
      employeeId: 1,
      employeeName: 'Ahmet Yılmaz',
      title: 'İş Sözleşmesi',
      type: 'contract',
      uploadDate: '2022-03-15',
      fileUrl: '#'
    },
    {
      id: 2,
      employeeId: 1,
      employeeName: 'Ahmet Yılmaz',
      title: 'Kimlik Fotokopisi',
      type: 'id',
      uploadDate: '2022-03-15',
      fileUrl: '#'
    },
    {
      id: 3,
      employeeId: 2,
      employeeName: 'Ayşe Kaya',
      title: 'İş Sözleşmesi',
      type: 'contract',
      uploadDate: '2021-07-20',
      fileUrl: '#'
    }
  ]);

  const [employeeForm, setEmployeeForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    position: '',
    departmentId: '',
    hireDate: '',
    status: 'active'
  });

  const [departmentForm, setDepartmentForm] = useState({
    name: ''
  });

  const [documentForm, setDocumentForm] = useState({
    employeeId: '',
    title: '',
    type: '',
    file: null
  });

  const documentTypes = [
    { value: 'contract', label: 'İş Sözleşmesi' },
    { value: 'id', label: 'Kimlik' },
    { value: 'diploma', label: 'Diploma' },
    { value: 'cv', label: 'CV' },
    { value: 'other', label: 'Diğer' }
  ];

  const handleAddEmployee = () => {
    setEmployeeForm({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      position: '',
      departmentId: '',
      hireDate: '',
      status: 'active'
    });
    setEditingEmployee(null);
    setIsEmployeeModalOpen(true);
  };

  const handleSaveEmployee = () => {
    if (!employeeForm.firstName || !employeeForm.lastName || !employeeForm.email || !employeeForm.departmentId) {
      Notify.warning('Lütfen zorunlu alanları doldurun');
      return;
    }

    const department = departments.find(dept => dept.id === parseInt(employeeForm.departmentId));
    
    if (editingEmployee) {
      setEmployees(employees.map(emp =>
        emp.id === editingEmployee.id
          ? {
              ...emp,
              ...employeeForm,
              departmentId: parseInt(employeeForm.departmentId),
              departmentName: department?.name || ''
            }
          : emp
      ));
      Notify.success('Çalışan bilgileri güncellendi!');
    } else {
      const newEmployee = {
        id: employees.length + 1,
        ...employeeForm,
        departmentId: parseInt(employeeForm.departmentId),
        departmentName: department?.name || '',
        avatar: null
      };
      setEmployees([...employees, newEmployee]);
      setDepartments(departments.map(dept =>
        dept.id === parseInt(employeeForm.departmentId)
          ? { ...dept, employeeCount: dept.employeeCount + 1 }
          : dept
      ));
      Notify.success('Çalışan eklendi!');
    }

    setIsEmployeeModalOpen(false);
    setEmployeeForm({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      position: '',
      departmentId: '',
      hireDate: '',
      status: 'active'
    });
    setEditingEmployee(null);
  };

  const handleEditEmployee = (employee) => {
    setEditingEmployee(employee);
    setEmployeeForm({
      firstName: employee.firstName,
      lastName: employee.lastName,
      email: employee.email,
      phone: employee.phone,
      position: employee.position,
      departmentId: employee.departmentId.toString(),
      hireDate: employee.hireDate,
      status: employee.status
    });
    setIsEmployeeModalOpen(true);
  };

  const handleDeleteEmployee = (employeeId) => {
    const employee = employees.find(emp => emp.id === employeeId);
    if (employee) {
      setEmployees(employees.filter(emp => emp.id !== employeeId));
      setDepartments(departments.map(dept =>
        dept.id === employee.departmentId
          ? { ...dept, employeeCount: Math.max(0, dept.employeeCount - 1) }
          : dept
      ));
      setDocuments(documents.filter(doc => doc.employeeId !== employeeId));
      Notify.success('Çalışan silindi');
    }
  };

  const handleAddDepartment = () => {
    setDepartmentForm({ name: '' });
    setIsDepartmentModalOpen(true);
  };

  const handleSaveDepartment = () => {
    if (!departmentForm.name.trim()) {
      Notify.warning('Birim adı gerekli');
      return;
    }

    const newDepartment = {
      id: departments.length + 1,
      name: departmentForm.name,
      employeeCount: 0
    };

    setDepartments([...departments, newDepartment]);
    setIsDepartmentModalOpen(false);
    setDepartmentForm({ name: '' });
    Notify.success('Birim eklendi!');
  };

  const handleDeleteDepartment = (departmentId) => {
    const dept = departments.find(d => d.id === departmentId);
    if (dept && dept.employeeCount > 0) {
      Notify.warning('Birimde çalışanlar olduğu için silinemez');
      return;
    }
    setDepartments(departments.filter(d => d.id !== departmentId));
    Notify.success('Birim silindi');
  };

  const handleAddDocument = () => {
    setDocumentForm({ employeeId: '', title: '', type: '', file: null });
    setIsDocumentModalOpen(true);
  };

  const handleSaveDocument = () => {
    if (!documentForm.employeeId || !documentForm.title || !documentForm.type) {
      Notify.warning('Lütfen tüm alanları doldurun');
      return;
    }

    const employee = employees.find(emp => emp.id === parseInt(documentForm.employeeId));
    if (!employee) return;

    const newDocument = {
      id: documents.length + 1,
      employeeId: parseInt(documentForm.employeeId),
      employeeName: `${employee.firstName} ${employee.lastName}`,
      title: documentForm.title,
      type: documentForm.type,
      uploadDate: new Date().toISOString().split('T')[0],
      fileUrl: '#'
    };

    setDocuments([...documents, newDocument]);
    setIsDocumentModalOpen(false);
    setDocumentForm({ employeeId: '', title: '', type: '', file: null });
    Notify.success('Dosya eklendi!');
  };

  const filteredEmployees = employees.filter(emp =>
    `${emp.firstName} ${emp.lastName}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
    emp.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    emp.position.toLowerCase().includes(searchTerm.toLowerCase()) ||
    emp.departmentName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredDocuments = documents.filter(doc =>
    doc.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    doc.employeeName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="w-full dark:bg-dark-100 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4 py-6">
        <HeaderComponent title="İnsan Kaynakları" />

        <Tabs
          selectedKey={activeTab}
          onSelectionChange={setActiveTab}
          className="mt-6"
          classNames={{
            tabList: "bg-white dark:bg-dark-300 border border-gray-200 dark:border-dark-400 shadow-none",
            tab: "data-[selected=true]:bg-blue-50 dark:data-[selected=true]:bg-blue-900/20 data-[selected=true]:text-blue-600 dark:data-[selected=true]:text-blue-400",
            cursor: "bg-blue-100 dark:bg-blue-900/30"
          }}
        >
          <Tab key="employees" title="Çalışanlar" />
          <Tab key="departments" title="Birimler" />
          <Tab key="documents" title="Özlük Dosyaları" />
        </Tabs>

        <div className="mt-6">
          {/* Çalışanlar Sekmesi */}
          {activeTab === 'employees' && (
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <Input
                  placeholder="Çalışan ara..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  startContent={<FiSearch className="text-gray-400" />}
                  className="max-w-xs"
                  classNames={{
                    input: "border border-gray-200 dark:border-dark-400",
                    inputWrapper: "border border-gray-200 dark:border-dark-400"
                  }}
                />
                <Button
                  className="bg-blue-600 hover:bg-blue-700 text-white"
                  startContent={<FiPlus className="w-4 h-4" />}
                  onPress={handleAddEmployee}
                >
                  Çalışan Ekle
                </Button>
              </div>

              <Card className="border border-gray-200 dark:border-dark-300 bg-white dark:bg-dark-300 shadow-none">
                <CardBody className="p-0">
                  <div className="divide-y divide-gray-200 dark:divide-dark-400">
                    {filteredEmployees.length === 0 ? (
                      <div className="p-8 text-center text-gray-500 dark:text-gray-400">
                        <FiUsers className="w-12 h-12 mx-auto mb-2 opacity-30" />
                        <p>Çalışan bulunamadı</p>
                      </div>
                    ) : (
                      filteredEmployees.map((employee) => (
                        <div
                          key={employee.id}
                          className="p-4 hover:bg-gray-50 dark:hover:bg-dark-400 transition-colors"
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-4 flex-1">
                              <Avatar
                                name={`${employee.firstName} ${employee.lastName}`}
                                size="lg"
                                className="bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400"
                              />
                              <div className="flex-1">
                                <div className="flex items-center gap-2 mb-1">
                                  <h3 className="font-semibold text-[#283252] dark:text-darkWhite-300">
                                    {employee.firstName} {employee.lastName}
                                  </h3>
                                  <Chip
                                    size="sm"
                                    variant="flat"
                                    className={
                                      employee.status === 'active'
                                        ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300'
                                        : 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300'
                                    }
                                  >
                                    {employee.status === 'active' ? 'Aktif' : 'Pasif'}
                                  </Chip>
                                </div>
                                <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">{employee.position}</p>
                                <div className="flex items-center gap-4 text-xs text-gray-500 dark:text-gray-400">
                                  <span className="flex items-center gap-1">
                                    <FiBriefcase className="w-3 h-3" />
                                    {employee.departmentName}
                                  </span>
                                  <span className="flex items-center gap-1">
                                    <FiMail className="w-3 h-3" />
                                    {employee.email}
                                  </span>
                                  <span className="flex items-center gap-1">
                                    <FiCalendar className="w-3 h-3" />
                                    {new Date(employee.hireDate).toLocaleDateString('tr-TR')}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="flex items-center gap-2">
                              <Button
                                isIconOnly
                                size="sm"
                                variant="light"
                                onPress={() => handleEditEmployee(employee)}
                              >
                                <FiEdit2 className="w-4 h-4" />
                              </Button>
                              <Button
                                isIconOnly
                                size="sm"
                                variant="light"
                                className="text-red-400"
                                onPress={() => handleDeleteEmployee(employee.id)}
                              >
                                <FiTrash2 className="w-4 h-4" />
                              </Button>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </CardBody>
              </Card>
            </div>
          )}

          {/* Birimler Sekmesi */}
          {activeTab === 'departments' && (
            <div className="space-y-4">
              <div className="flex justify-end">
                <Button
                  className="bg-blue-600 hover:bg-blue-700 text-white"
                  startContent={<FiPlus className="w-4 h-4" />}
                  onPress={handleAddDepartment}
                >
                  Birim Ekle
                </Button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {departments.map((department) => (
                  <Card key={department.id} className="border border-gray-200 dark:border-dark-300 bg-white dark:bg-dark-300 shadow-none">
                    <CardBody className="p-5">
                      <div className="flex items-start justify-between mb-4">
                        <div>
                          <h3 className="font-semibold text-[#283252] dark:text-darkWhite-300 mb-1">
                            {department.name}
                          </h3>
                          <p className="text-sm text-gray-600 dark:text-gray-400">
                            {department.employeeCount} çalışan
                          </p>
                        </div>
                        <Button
                          isIconOnly
                          size="sm"
                          variant="light"
                          className="text-red-400"
                          onPress={() => handleDeleteDepartment(department.id)}
                        >
                          <FiTrash2 className="w-4 h-4" />
                        </Button>
                      </div>
                    </CardBody>
                  </Card>
                ))}
              </div>
            </div>
          )}

          {/* Özlük Dosyaları Sekmesi */}
          {activeTab === 'documents' && (
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <Input
                  placeholder="Dosya ara..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  startContent={<FiSearch className="text-gray-400" />}
                  className="max-w-xs"
                  classNames={{
                    input: "border border-gray-200 dark:border-dark-400",
                    inputWrapper: "border border-gray-200 dark:border-dark-400"
                  }}
                />
                <Button
                  className="bg-blue-600 hover:bg-blue-700 text-white"
                  startContent={<FiPlus className="w-4 h-4" />}
                  onPress={handleAddDocument}
                >
                  Dosya Ekle
                </Button>
              </div>

              <Card className="border border-gray-200 dark:border-dark-300 bg-white dark:bg-dark-300 shadow-none">
                <CardBody className="p-0">
                  <div className="divide-y divide-gray-200 dark:divide-dark-400">
                    {filteredDocuments.length === 0 ? (
                      <div className="p-8 text-center text-gray-500 dark:text-gray-400">
                        <FiFileText className="w-12 h-12 mx-auto mb-2 opacity-30" />
                        <p>Dosya bulunamadı</p>
                      </div>
                    ) : (
                      filteredDocuments.map((document) => (
                        <div
                          key={document.id}
                          className="p-4 hover:bg-gray-50 dark:hover:bg-dark-400 transition-colors"
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-4">
                              <div className="p-2 rounded-lg bg-blue-100 dark:bg-blue-900/30">
                                <FiFileText className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                              </div>
                              <div>
                                <h3 className="font-semibold text-[#283252] dark:text-darkWhite-300 mb-1">
                                  {document.title}
                                </h3>
                                <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
                                  {document.employeeName}
                                </p>
                                <div className="flex items-center gap-4 text-xs text-gray-500 dark:text-gray-400">
                                  <span>
                                    {documentTypes.find(t => t.value === document.type)?.label || document.type}
                                  </span>
                                  <span>{new Date(document.uploadDate).toLocaleDateString('tr-TR')}</span>
                                </div>
                              </div>
                            </div>
                            <Button
                              size="sm"
                              variant="light"
                              startContent={<FiFileText className="w-4 h-4" />}
                              onPress={() => window.open(document.fileUrl, '_blank')}
                            >
                              Görüntüle
                            </Button>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </CardBody>
              </Card>
            </div>
          )}
        </div>

        {/* Çalışan Ekleme/Düzenleme Modal */}
        <Modal isOpen={isEmployeeModalOpen} onClose={() => setIsEmployeeModalOpen(false)} size="lg">
          <ModalContent>
            <ModalHeader>{editingEmployee ? 'Çalışan Düzenle' : 'Yeni Çalışan Ekle'}</ModalHeader>
            <ModalBody>
              <div className="grid grid-cols-2 gap-4">
                <Input
                  label="Ad"
                  placeholder="Ad"
                  value={employeeForm.firstName}
                  onChange={(e) => setEmployeeForm({ ...employeeForm, firstName: e.target.value })}
                  isRequired
                  classNames={{
                    input: "border border-gray-200 dark:border-dark-400",
                    inputWrapper: "border border-gray-200 dark:border-dark-400"
                  }}
                />
                <Input
                  label="Soyad"
                  placeholder="Soyad"
                  value={employeeForm.lastName}
                  onChange={(e) => setEmployeeForm({ ...employeeForm, lastName: e.target.value })}
                  isRequired
                  classNames={{
                    input: "border border-gray-200 dark:border-dark-400",
                    inputWrapper: "border border-gray-200 dark:border-dark-400"
                  }}
                />
              </div>
              <Input
                label="E-posta"
                placeholder="ornek@heypena.com"
                type="email"
                value={employeeForm.email}
                onChange={(e) => setEmployeeForm({ ...employeeForm, email: e.target.value })}
                isRequired
                startContent={<FiMail className="text-gray-400" />}
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
              <Input
                label="Telefon"
                placeholder="+90 555 123 4567"
                value={employeeForm.phone}
                onChange={(e) => setEmployeeForm({ ...employeeForm, phone: e.target.value })}
                startContent={<FiPhone className="text-gray-400" />}
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
              <Input
                label="Pozisyon"
                placeholder="örn: Senior Developer"
                value={employeeForm.position}
                onChange={(e) => setEmployeeForm({ ...employeeForm, position: e.target.value })}
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
              <Select
                label="Birim"
                placeholder="Birim seçin"
                selectedKeys={employeeForm.departmentId ? [employeeForm.departmentId] : []}
                onSelectionChange={(keys) => {
                  const selected = Array.from(keys)[0];
                  setEmployeeForm({ ...employeeForm, departmentId: selected || '' });
                }}
                isRequired
                classNames={{
                  trigger: "border border-gray-200 dark:border-dark-400"
                }}
              >
                {departments.map((dept) => (
                  <SelectItem key={dept.id.toString()} value={dept.id.toString()}>
                    {dept.name}
                  </SelectItem>
                ))}
              </Select>
              <Input
                type="date"
                label="İşe Giriş Tarihi"
                value={employeeForm.hireDate}
                onChange={(e) => setEmployeeForm({ ...employeeForm, hireDate: e.target.value })}
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
              <Select
                label="Durum"
                selectedKeys={employeeForm.status ? [employeeForm.status] : []}
                onSelectionChange={(keys) => {
                  const selected = Array.from(keys)[0];
                  setEmployeeForm({ ...employeeForm, status: selected || 'active' });
                }}
                classNames={{
                  trigger: "border border-gray-200 dark:border-dark-400"
                }}
              >
                <SelectItem key="active">Aktif</SelectItem>
                <SelectItem key="inactive">Pasif</SelectItem>
              </Select>
            </ModalBody>
            <ModalFooter>
              <Button variant="light" onPress={() => setIsEmployeeModalOpen(false)}>
                İptal
              </Button>
              <Button className="bg-blue-600 text-white" onPress={handleSaveEmployee}>
                {editingEmployee ? 'Güncelle' : 'Ekle'}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Birim Ekleme Modal */}
        <Modal isOpen={isDepartmentModalOpen} onClose={() => setIsDepartmentModalOpen(false)}>
          <ModalContent>
            <ModalHeader>Yeni Birim Ekle</ModalHeader>
            <ModalBody>
              <Input
                label="Birim Adı"
                placeholder="örn: Yazılım Geliştirme"
                value={departmentForm.name}
                onChange={(e) => setDepartmentForm({ name: e.target.value })}
                isRequired
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button variant="light" onPress={() => setIsDepartmentModalOpen(false)}>
                İptal
              </Button>
              <Button className="bg-blue-600 text-white" onPress={handleSaveDepartment}>
                Ekle
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Dosya Ekleme Modal */}
        <Modal isOpen={isDocumentModalOpen} onClose={() => setIsDocumentModalOpen(false)} size="lg">
          <ModalContent>
            <ModalHeader>Özlük Dosyası Ekle</ModalHeader>
            <ModalBody>
              <Select
                label="Çalışan"
                placeholder="Çalışan seçin"
                selectedKeys={documentForm.employeeId ? [documentForm.employeeId] : []}
                onSelectionChange={(keys) => {
                  const selected = Array.from(keys)[0];
                  setDocumentForm({ ...documentForm, employeeId: selected || '' });
                }}
                isRequired
                classNames={{
                  trigger: "border border-gray-200 dark:border-dark-400"
                }}
              >
                {employees.map((emp) => (
                  <SelectItem key={emp.id.toString()} value={emp.id.toString()}>
                    {emp.firstName} {emp.lastName}
                  </SelectItem>
                ))}
              </Select>
              <Input
                label="Dosya Başlığı"
                placeholder="örn: İş Sözleşmesi"
                value={documentForm.title}
                onChange={(e) => setDocumentForm({ ...documentForm, title: e.target.value })}
                isRequired
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
              <Select
                label="Dosya Tipi"
                placeholder="Dosya tipi seçin"
                selectedKeys={documentForm.type ? [documentForm.type] : []}
                onSelectionChange={(keys) => {
                  const selected = Array.from(keys)[0];
                  setDocumentForm({ ...documentForm, type: selected || '' });
                }}
                isRequired
                classNames={{
                  trigger: "border border-gray-200 dark:border-dark-400"
                }}
              >
                {documentTypes.map((type) => (
                  <SelectItem key={type.value} value={type.value}>
                    {type.label}
                  </SelectItem>
                ))}
              </Select>
              <Input
                type="file"
                label="Dosya"
                onChange={(e) => setDocumentForm({ ...documentForm, file: e.target.files[0] })}
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button variant="light" onPress={() => setIsDocumentModalOpen(false)}>
                İptal
              </Button>
              <Button className="bg-blue-600 text-white" onPress={handleSaveDocument}>
                Ekle
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </div>
    </div>
  );
}

